import { useState } from 'react';
import { FooterConfig } from '@/lib/themeConfig';
import { SaveButton } from './GeneralSection';

interface Props {
  data: FooterConfig;
  onChange: (data: FooterConfig) => void;
}

export default function FooterSection({ data, onChange }: Props) {
  const [local, setLocal] = useState<FooterConfig>(data);
  const [saved, setSaved] = useState(false);

  const handleSave = () => { onChange(local); setSaved(true); setTimeout(() => setSaved(false), 2000); };

  const updateShopLink = (i: number, key: 'label' | 'href', val: string) => {
    const next = local.shop_links.map((l, idx) => idx === i ? { ...l, [key]: val } : l);
    setLocal(p => ({ ...p, shop_links: next }));
  };
  const updateInfoLink = (i: number, key: 'label' | 'href', val: string) => {
    const next = local.info_links.map((l, idx) => idx === i ? { ...l, [key]: val } : l);
    setLocal(p => ({ ...p, info_links: next }));
  };
  const addShopLink = () => setLocal(p => ({ ...p, shop_links: [...p.shop_links, { label: '', href: '/' }] }));
  const removeShopLink = (i: number) => setLocal(p => ({ ...p, shop_links: p.shop_links.filter((_, idx) => idx !== i) }));
  const addInfoLink = () => setLocal(p => ({ ...p, info_links: [...p.info_links, { label: '', href: '/' }] }));
  const removeInfoLink = (i: number) => setLocal(p => ({ ...p, info_links: p.info_links.filter((_, idx) => idx !== i) }));

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white rounded-2xl p-6 space-y-4">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Footer Açıklaması</h2>
        <textarea
          value={local.description}
          onChange={e => setLocal(p => ({ ...p, description: e.target.value }))}
          rows={3}
          className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none"
        />
      </div>

      <div className="bg-white rounded-2xl p-6 space-y-3">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Koleksiyon Linkleri</h2>
        {local.shop_links.map((l, i) => (
          <div key={i} className="flex gap-2 items-center">
            <input type="text" value={l.label} onChange={e => updateShopLink(i, 'label', e.target.value)} placeholder="Etiket" className="flex-1 px-3 py-2 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" />
            <input type="text" value={l.href} onChange={e => updateShopLink(i, 'href', e.target.value)} placeholder="/urunler" className="flex-1 px-3 py-2 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" />
            <button onClick={() => removeShopLink(i)} className="w-8 h-8 flex items-center justify-center text-red-400 hover:text-red-600 cursor-pointer flex-shrink-0"><i className="ri-delete-bin-line" /></button>
          </div>
        ))}
        <button onClick={addShopLink} className="text-xs text-amber-600 hover:text-amber-700 cursor-pointer flex items-center gap-1"><i className="ri-add-line" /> Ekle</button>
      </div>

      <div className="bg-white rounded-2xl p-6 space-y-3">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Bilgi Linkleri</h2>
        {local.info_links.map((l, i) => (
          <div key={i} className="flex gap-2 items-center">
            <input type="text" value={l.label} onChange={e => updateInfoLink(i, 'label', e.target.value)} placeholder="Etiket" className="flex-1 px-3 py-2 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" />
            <input type="text" value={l.href} onChange={e => updateInfoLink(i, 'href', e.target.value)} placeholder="/hakkimizda" className="flex-1 px-3 py-2 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" />
            <button onClick={() => removeInfoLink(i)} className="w-8 h-8 flex items-center justify-center text-red-400 hover:text-red-600 cursor-pointer flex-shrink-0"><i className="ri-delete-bin-line" /></button>
          </div>
        ))}
        <button onClick={addInfoLink} className="text-xs text-amber-600 hover:text-amber-700 cursor-pointer flex items-center gap-1"><i className="ri-add-line" /> Ekle</button>
      </div>

      <SaveButton saved={saved} onSave={handleSave} />
    </div>
  );
}
